
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nse15a544483db3a3cc84863bd62922b67en from './en.yaml'
            i18n.addResourceBundle('en', 'e15a544483db3a3cc84863bd62922b67', flattenObject(nse15a544483db3a3cc84863bd62922b67en), true, true);
        
        export default 'e15a544483db3a3cc84863bd62922b67';
    